import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class CashAccountBalancePaymentTypeDTO  {
    _originalTypeClassName = "zERP.BO.CashAccountBalancePaymentTypeDTO";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
CashAccountBalancePaymentTypeDTO.translate = translateService;
}
this.ReceivedInvoicesNumber = null;
this.ReceivedAmount = null;
this.PaidInvoicesNumber = null;
this.PaidAmount = null;
this.Balance = null;
this.CashAccountBalancePaymentTypeDTOKey = null;
this._key = this.CashAccountBalancePaymentTypeDTOKey = 0; 
}

static translate: TranslateService;
_key: any;
ReceivedInvoicesNumber:any;
ReceivedAmount:any;
PaidInvoicesNumber:any;
PaidAmount:any;
Balance:any;
private _CashAccountBalancePaymentTypeDTOKey:any;
get CashAccountBalancePaymentTypeDTOKey(): any {
    return this._CashAccountBalancePaymentTypeDTOKey;
  }
set CashAccountBalancePaymentTypeDTOKey(value: any) {
    this._CashAccountBalancePaymentTypeDTOKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.CashAccountBalancePaymentTypeDTOKey == null || $this.CashAccountBalancePaymentTypeDTOKey == 0;
            }


}